import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const CAN_ACTIVATE_AUTH_GUARD: CanActivateFn = (route, state) => {
  const msalGuard = inject(MsalGuard);
  return msalGuard.canActivate(route, state);
};
